import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { Offer } from '@funtech-int/yango-shared';

import { TextWeight, Text, TextTag, TextSize, Theme } from '@/shared/components/Text';
import { getOfferTitle } from '@/shared/lib/analytics';

import styles from './OfferContent.module.css';

interface Props {
    offer: Offer;
    isUpsale?: boolean;
}

const getOfferContentTexts = (offer: Offer, isUpsale: boolean) => {
    if (isUpsale) {
        return {
            title: offer.offerTexts.subscriptionName,
            subtitle: getOfferTitle(offer),
        };
    }

    return {
        title: offer.offerTexts.buttonText,
        subtitle: offer.offerTexts.buttonTextWithDetails,
    };
};

export const OfferContentComponent: FunctionComponent<Props> = ({ offer, isUpsale }) => {
    const { title, subtitle } = getOfferContentTexts(offer, Boolean(isUpsale));

    return (
        <div className={classnames(styles.root, { [styles.isUpsale]: isUpsale })}>
            <Text
                className={styles.title}
                theme={Theme.Dark}
                tag={TextTag.P}
                weight={isUpsale ? TextWeight.Semibold : TextWeight.Heavy}
                size={isUpsale ? TextSize.Title : TextSize.Superhead}
            >
                {title}
            </Text>
            <Text
                className={styles.subtitle}
                theme={Theme.Grey}
                tag={TextTag.P}
                weight={TextWeight.Regular}
                size={TextSize.Body}
            >
                {subtitle}
            </Text>
        </div>
    );
};
